import { useState } from 'react'
import { AuthProvider, useAuth } from './hooks/useAuth'
import AuthPage from './pages/AuthPage'
import ScanPage from './pages/ScanPage'
import DashboardPage from './pages/DashboardPage'
import RewardsPage from './pages/RewardsPage'
import ProfilePage from './pages/ProfilePage'
import MapPage from './pages/MapPage'
import BottomNav from './components/BottomNav'
import './App.css'

function AppContent() {
  const { user, loading } = useAuth()
  const [tab, setTab] = useState('scan')

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', flexDirection:'column', gap:12, background:'#f0faf4' }}>
      <span style={{ fontSize:56 }}>♻️</span>
      <p style={{ color:'#1A6B3C', fontWeight:700, fontSize:22, margin:0 }}>WasteReward</p>
      <p style={{ color:'#888', fontSize:13, margin:0 }}>by Softminds</p>
    </div>
  )

  if (!user) return <AuthPage />

  return (
    <div style={{ minHeight:'100vh', background:'#f0faf4', paddingBottom:80 }}>
      {/* Header */}
      <header style={headerStyle}>
        <span style={{ fontWeight:700, fontSize:18 }}>♻️ WasteReward</span>
        <a
          href="https://softminds.gr"
          target="_blank"
          rel="noopener noreferrer"
          style={devLinkStyle}
        >
          by Softminds
        </a>
      </header>

      <main style={{ paddingTop:60 }}>
        {tab === 'scan'      && <ScanPage onScanSuccess={() => {}} />}
        {tab === 'map'       && <MapPage />}
        {tab === 'dashboard' && <DashboardPage />}
        {tab === 'rewards'   && <RewardsPage />}
        {tab === 'profile'   && <ProfilePage />}
      </main>

      <BottomNav active={tab} onChange={setTab} />
    </div>
  )
}

const headerStyle = {
  position:'fixed', top:0, left:0, right:0, height:60,
  background:'#1A6B3C', color:'white',
  display:'flex', alignItems:'center', justifyContent:'space-between',
  padding:'0 1rem', zIndex:40
}

const devLinkStyle = {
  fontSize:12, color:'rgba(255,255,255,0.75)',
  textDecoration:'none', fontStyle:'italic',
  borderBottom:'1px solid rgba(255,255,255,0.3)',
  paddingBottom:1
}

export default function App() {
  return <AuthProvider><AppContent /></AuthProvider>
}
